import React, { useState } from "react";
import "./Curriculum.css"; // Importing CSS
import preprimaryImage from "../../Assets/pre-primary.jpg";
import PrimaryImage from "../../Assets/primary.jpg";
import HighschoolImage from "../../Assets/highschool.jpg";
import IIT from "../../Assets/iit.jpg";
import Culturals from "../../Assets/cultural.jpg";
import Sports from "../../Assets/sports.jpg";
import Other from "../../Assets/other.jpg";

const Curriculum = () => {
  const [activeTab, setActiveTab] = useState("academics");

  const academicsData = [
    {
      title: "Pre-Primary Education",
      description: (
        
        <ul className="justified-list">
          <li>Child-centered curriculum and unmatched ambience</li>
          <li>Committed teachers to facilitate child's learning</li>
          <li>Play way method of teaching</li>
          <li>Encouraging curiosity in children</li>
          <li>Individual care and attention</li>
          <li>Parents as partners in child's growth and development</li>
          <li>Digital classes</li>
          <li>Activity-based teaching aids</li>
        </ul>
      ),
      image: preprimaryImage,
    },
    {
      title: "Primary Education",
      description: (
        <ul className="justified-list">
          <li>Qualified and experienced faculty</li>
          <li>Well-furnished classrooms</li>
          <li>Creating a learning atmosphere and providing quality education</li>
          <li>Predicting child aptitude</li>
          <li>Conducting various competitions</li>
          <li>Providing basic computer knowledge</li>
          <li>Audio-visual and play-way method of teaching</li>
          <li>Personal intensive care for slow learners</li>
        </ul>
      ),
      image: PrimaryImage,
    },
    {
      title: "High School Education",
      description: (
        <ul className="justified-list">
          <li>Advanced curriculum aligned with board standards</li>
          <li>Highly qualified and experienced teachers</li>
          <li>Regular assessments and performance tracking</li>
          <li>Interactive learning through interesting pedagogy</li>
          <li>Practical and lab-based learning</li>
          <li>Career counseling and guidance</li>
        </ul>
      ),
      image: HighschoolImage,
    },
    {
      title: "IIT Program",
      description: (
        <ul className="justified-list">
          <li>Specialized coaching for IIT aspirants</li>
          <li>Expert mentorship and guidance</li>
          <li>Comprehensive study materials</li>
          <li>Regular assessments and feedback</li>
        </ul>
      ),
      image: IIT,
    },
  ];

  const beyondAcademicsData = [
    {
      title: "Cultural Activities",
      description: (
        <ul className="justified-list">
          <li>Encouraging creativity through dance, music, and drama</li>
          <li>Annual cultural events and competitions</li>
          <li>Workshops with professional artists</li>
        </ul>
      ),
      image: Culturals,
    },
    {
      title: "Sports",
      description: (
        <ul className="justified-list">
          <li>Developing teamwork and discipline</li>
          <li>Special yoga classes</li>
          <li>Weekly mass drill</li>
          <li>Physical fitness and well-being</li>
          <li>Encouraging sportsmanship</li>
        </ul>
      ),
      image: Sports,
    },
    {
      title: "Other Programs",
      description: (
        <ul className="justified-list">
          <li>Various clubs and events to enhance student engagement</li>
          <li>Leadership and personal development programs</li>
          <li>Community service and social responsibility initiatives</li>
        </ul>
      ),
      image: Other,
    },
  ];

  // Schedule Data
  const scheduleData = [
    { assessment: "F.A. - 1", timeline: "2nd week of July" },
    { assessment: "F.A. - 2", timeline: "3rd week of August" },
    { assessment: "S.A. - 1", timeline: "In the month of October" },
    { assessment: "F.A. - 3", timeline: "4th week of November" },
    { assessment: "F.A. - 4", timeline: "4th week of January" },
    { assessment: "S.A. - 2", timeline: "In the month of March" },
  ];

  return (
    <div className="curriculum-container">
      {/* Tabs for Switching */}
      <div className="tab-switcher">
        <button
          className={activeTab === "academics" ? "active-tab" : ""}
          onClick={() => setActiveTab("academics")}
        >
          Academics
        </button>
        <button
          className={activeTab === "beyond-academics" ? "active-tab" : ""}
          onClick={() => setActiveTab("beyond-academics")}
        >
          Beyond Academics
        </button>
        <button
          className={activeTab === "schedule" ? "active-tab" : ""}
          onClick={() => setActiveTab("schedule")}
        >
          Schedule
        </button>
      </div>

      {/* Display content based on selected tab */}
      {activeTab === "academics" && (
        <div className="flash-cards">
          {academicsData.map((item, index) => (
            <div className="flash-card" key={index}>
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
              <div>{item.description}</div>
            </div>
          ))}
        </div>
      )}

      {activeTab === "beyond-academics" && (
        <div className="flash-cards">
          {beyondAcademicsData.map((item, index) => (
            <div className="flash-card" key={index}>
              <img src={item.image} alt={item.title} />
              <h3>{item.title}</h3>
              <div>{item.description}</div>
            </div>
          ))}
        </div>
      )}

      {activeTab === "schedule" && (
        <div className="schedule-table">
          <h2>Assessment Schedule</h2>
          <table>
            <thead>
              <tr>
                <th>Assessment</th>
                <th>Timeline</th>
              </tr>
            </thead>
            <tbody>
              {scheduleData.map((item, index) => (
                <tr key={index}>
                  <td>{item.assessment}</td>
                  <td>{item.timeline}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Curriculum;
